import { GET_SCHEDULED_TOURS_REQUEST, GET_SCHEDULED_TOURS_SUCCESS, GET_SCHEDULED_TOURS_FAIL } from '../types/actionTypes';

export const scheduleToursReducer = (state = {}, action: any) => {
  switch (action.type) {
    case GET_SCHEDULED_TOURS_REQUEST:
      return { ...state, loading: true };
    case GET_SCHEDULED_TOURS_SUCCESS:
      return { loading: false, scheduledTours: action.payload };
    case GET_SCHEDULED_TOURS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
